import React from 'react';
import { Navigate } from 'react-router-dom';

function AdminRoute({ user, children }) {
  if (!user || user.userType !== 'admin') {
    return <Navigate to="/home" replace />;
  }

  return children;
}

export default AdminRoute;
